import createIcon from '../../createIcon';

/**
 * @component @name SignalCellularAlt2Bar
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNNy41IDExLjVIMTAuNVYxNy41SDcuNVYxMS41Wk0xMy41IDYuNUgxNi41VjE3LjVIMTMuNVY2LjVaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const SignalCellularAlt2Bar = createIcon('SignalCellularAlt2Bar', [
  ['path', { d: 'M7.5 11.5H10.5V17.5H7.5V11.5ZM13.5 6.5H16.5V17.5H13.5V6.5Z', key: 'pe2agy' }],
]);

export default SignalCellularAlt2Bar;
